import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c868ec80&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c868ec80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c868ec80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c868ec80')) {
      api.createRecord('c868ec80', component.options)
    } else {
      api.reload('c868ec80', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c868ec80&scoped=true&", function () {
      api.rerender('c868ec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RvuKlSpKx80Z/JS/comp/DocBox.vue"
export default component.exports